import i18n from 'i18next';
import HttpBackend from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';

i18n
  .use(HttpBackend)
  .use(initReactI18next)
  .init({
    lng: 'pl',
    fallbackLng: 'en',
    interpolation: { escapeValue: false },
    // Wersjonowany URL omija KAŻDY stary cache (przeglądarka/edge) po deployu.
    backend: { loadPath: '/locales/{{lng}}/translation.json?v=' + (process.env.BUILD_ID ?? 'dev') },
    react: { useSuspense: true }
  });

export default i18n;
